<div class="flex flex-col gap-2 pt-2" *ngIf="canUpload">

  <mat-card class="drop-zone"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)">
  <input type="file"
         hidden
         #fileInput
         accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
        (change)="onFileSelected($event)"
        multiple/>

  <p>Drag and drop files here, or choose files to upload.</p>
  <button type="button" mat-stroked-button color="primary" (click)="fileInput.click()">
    <mat-icon>cloud_upload</mat-icon> Choose files
  </button>
</mat-card>

  <div class="flex flex-row justify-start items-center gap-4">
    <div class="flex flex-col" *ngIf="uploading">
      <mat-progress-bar mode="determinate" [value]="uploadProgress"></mat-progress-bar>
      <span>Uploading: {{ uploadProgress }}%</span>
    </div>
    <div class="flex flex-col" *ngIf="downloading">
        <mat-progress-bar mode="determinate" [value]="downloadProgress"></mat-progress-bar>
      <span>Downloading: {{ downloadProgress }}%</span>
    </div>
  </div>

  <div class="flex flex-col">
    <span class="font-semibold">Current Documents</span>
    <div *ngFor="let document of documents">
      <span>{{ document.name }}</span>
    </div>
  </div>
</div>
